<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  window.location.reload();
});
</script>

<template></template>
